import { Component } from '@angular/core';
import { SocketService } from '../socket.service';

@Component({
  standalone: true,
  imports: [],
  templateUrl: './notfound.component.html',
  styleUrl: './notfound.component.scss'
})
export class NotfoundComponent {

  constructor() {

  }
}
